"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactIntl = require("react-intl");
var _Money = _interopRequireDefault(require("./Money"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/no-unstable-nested-components */
var BoldText = (0, _styles.styled)('span')(function (_ref) {
  var theme = _ref.theme;
  return {
    fontWeight: theme.typography.fontWeightBold
  };
});
var RedText = (0, _styles.styled)('span')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontWeight: theme.typography.fontWeightBold,
    color: 'red'
  };
});
var Highlight = (0, _styles.styled)('span')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main
  };
});
var GreenText = (0, _styles.styled)('span')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    fontWeight: theme.typography.fontWeightBold,
    color: 'green'
  };
});
function FormattedTranslationMui(_ref5) {
  var defaultMessage = _ref5.defaultMessage,
    id = _ref5.id,
    onClick = _ref5.onClick,
    values = _ref5.values;
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: id,
    defaultMessage: defaultMessage,
    values: _objectSpread({
      a: function a(chunks) {
        return /*#__PURE__*/_react["default"].createElement(_core.Link, {
          onClick: onClick
        }, chunks);
      },
      red: function red(chunks) {
        return /*#__PURE__*/_react["default"].createElement(RedText, null, chunks);
      },
      highlight: function highlight(chunks) {
        return /*#__PURE__*/_react["default"].createElement(Highlight, null, chunks);
      },
      green: function green(chunks) {
        return /*#__PURE__*/_react["default"].createElement(GreenText, null, chunks);
      },
      bold: function bold(chunks) {
        return /*#__PURE__*/_react["default"].createElement(BoldText, null, chunks);
      },
      money: function money(chunks) {
        return /*#__PURE__*/_react["default"].createElement(_Money["default"], {
          amount: chunks
        });
      },
      newLine: /*#__PURE__*/_react["default"].createElement("br", null)
    }, values)
  });
}
FormattedTranslationMui.propTypes = {
  defaultMessage: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func,
  values: _propTypes["default"].object
};
var _default = exports["default"] = FormattedTranslationMui;